<app-breadcrumb
  [master]="'Dobry Agent'"
  [parentName]="'Autorzy'"
  [name]="'Szczegóły'"
></app-breadcrumb>

<mat-tab-group>
  <mat-tab label="Dane">
    <app-da-author-details-view
      *ngIf="!modify"
      [author]="author"
      (modifyClicked)="modify = true"
    ></app-da-author-details-view>

    <app-da-author-add
      *ngIf="modify && authorObject"
      [author]="authorObject"
      [mod]="true"
      (closeModification)="onModificationClosed()"
    ></app-da-author-add>
  </mat-tab>
</mat-tab-group>
